import type { NavigationLink } from '../consts/links';

/** A link is active on its exact `href`, or on `activePathPrefix` and any route nested under it. */
export const isNavigationLinkActive = (link: NavigationLink, pathname: string) => {
  if (link.href && pathname === link.href) {
    return true;
  }

  const prefix = link.activePathPrefix;
  return !!prefix && (pathname === prefix || pathname.startsWith(`${prefix}/`));
};
